import React, { Fragment } from "react";
import { API_ROOT1 } from "./utils/api-config";
import Card from "react-bootstrap/Card";
import moment from "moment";

const ClickCard = ({
  id,
  customer_name,
  customer_id,
  merchant,
  date,
  link,
}) => {
  return (
    <Fragment>
      <style type="text/css">
        {`
    .btn-flat {
      background-color: #B8D5B6;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #E6E7E8;
      color: #534741;
      border-radius: 15px;  
    }
    .card-deck .card  {
      margin-bottom: 10px;  
      font-size: 1.2rem;
      display: flex;
    }
    .btn-xxl {
      padding: 10px;
      font-size: 1.2rem;
    }
    `}
      </style>
      <Card
        bg="flat"
        border="dark"
        style={{ minWidth: "300px", maxWidth: "300px" }}
      >
        <Card.Header className="d-flex justify-content-between">
          <span className="text-secondary">
            {moment(date).format("YYYY-MM-DD")}
          </span>{" "}
          {merchant}
        </Card.Header>
        <Card.Body>
          <Card.Title>
            <a
              href={
                customer_id == 8
                  ? null
                  : `${API_ROOT1}/customerdeliveries?id=${customer_id}`
              }
            >
              <span className="text-dark">{customer_name}</span>
            </a>
          </Card.Title>
          <Card.Text>
            <span className="text-dark">{link}</span> <br></br>
          </Card.Text>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default ClickCard;
